/**
 * WebApi
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ItemAttributeAnswerTypes = 'YesNo' | 'Text' | 'Number' | 'Money' | 'Options' | 'Document' | 'Hidden';

export const ItemAttributeAnswerTypes = {
    YesNo: 'YesNo' as ItemAttributeAnswerTypes,
    Text: 'Text' as ItemAttributeAnswerTypes,
    Number: 'Number' as ItemAttributeAnswerTypes,
    Money: 'Money' as ItemAttributeAnswerTypes,
    Options: 'Options' as ItemAttributeAnswerTypes,
    Document: 'Document' as ItemAttributeAnswerTypes,
    Hidden: 'Hidden' as ItemAttributeAnswerTypes
};

